import { Routes } from '@angular/router';
import { AuthGuard } from '@ov-suite/authguard-angular';
import { AdminLayoutComponent, RouteInfo } from '@ov-suite/ui';
import { FeatureKey } from '@ov-suite/helpers-shared/lib/feature.enum';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';

export const angularRoutes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'unauthorized',
    loadChildren: () => import('@ov-suite/authguard-angular').then(m => m.UnauthorizedModule),
    pathMatch: 'full',
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
      },
      {
        data: { feature: { id: FeatureKey.VIEW_PROFILE } },
        path: 'user',
        loadChildren: () => import('./modules/user/user.module').then(m => m.UserModule),
      },
      {
        data: { feature: { id: FeatureKey.MANAGE_USERS } },
        path: 'management/users',
        loadChildren: () => import('./modules/users/users.module').then(m => m.UsersModule),
      },
      {
        data: { feature: { id: FeatureKey.MANAGE_USERS } },
        path: 'management/user-type',
        loadChildren: () => import('./modules/user-type/user-type.module').then(m => m.UserTypeModule),
      },
      {
        path: 'notifications',
        loadChildren: () => import('@ov-suite/services-angular').then(m => m.NotificationsListModule),
      },
    ],
  },
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'privacy-policy',
        loadChildren: () => import('./modules/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule),
      },
    ],
  },
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'login',
        loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
      },
      // {
      //   path: '**',
      //   component: AuthLayoutComponent,
      // },
    ],
  },
];

export const sidebarRoutes: RouteInfo[] = [
  {
    path: '/dashboard',
    title: 'dashboard',
    icontype: 'fa fa-tachometer',
    type: 'link',
  },
  {
    path: '/management',
    title: 'User Management',
    type: 'sub',
    collapse: 'general-setup',
    icontype: 'fa fa-user-plus',
    children: [
      { path: 'user-type', title: 'User Types', ab: 'UT', permissionId: FeatureKey.MANAGE_USERS },
      { path: 'users', title: 'Users', ab: 'US', permissionId: FeatureKey.MANAGE_USERS },
    ],
  },
];
